module.exports = __webpack_public_path__ + "img/isaac_3.327bdd09.png";